import { ArrowRight } from "lucide-react";
import { Reveal } from "@/components/Reveal";
import { useApp } from "@/context/AppContext";
import { destinations } from "@/data/site";

export default function Destinations() {
  const { setPropFilter, scrollToId } = useApp();
  const select = (city) => { setPropFilter(city); scrollToId("strutture"); };
  return (
    <section id="destinazioni" className="py-24 md:py-32 bg-brand-ivory/50">
      <div className="max-w-7xl mx-auto px-6 md:px-12">
        <Reveal className="max-w-2xl">
          <p className="text-xs tracking-[0.35em] uppercase text-brand-gold mb-4">Destinazioni</p>
          <h2 className="font-heading font-light text-4xl md:text-5xl text-brand-black">Destinazioni</h2>
          <p className="mt-4 text-brand-brown text-lg">Ogni soggiorno, un modo diverso di scoprire l’Italia.</p>
        </Reveal>
        <div className="mt-10 grid grid-cols-1 md:grid-cols-2 gap-6">
          {destinations.map((d, i) => (
            <Reveal key={d.id} delay={i * 80}>
              <button
                data-testid={`destination-${d.id}`}
                onClick={() => select(d.filterCity)}
                className="group relative w-full h-72 md:h-80 rounded-2xl overflow-hidden text-left"
              >
                <img src={d.image} alt={d.name} loading="lazy" className="absolute inset-0 w-full h-full object-cover group-hover:scale-105 transition-transform duration-700" />
                <div className="absolute inset-0 bg-gradient-to-t from-black/70 via-black/20 to-transparent" />
                <div className="absolute bottom-0 p-7 text-white">
                  <h3 className="font-heading text-2xl md:text-3xl">{d.name}</h3>
                  <p className="text-sm text-white/85 mt-1 max-w-md">{d.text}</p>
                  <span className="mt-3 inline-flex items-center gap-2 text-sm font-medium text-brand-gold group-hover:gap-3 transition-all">
                    Vedi le strutture <ArrowRight className="w-4 h-4" />
                  </span>
                </div>
              </button>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
}
